<template>
	<div class="skintype">
		<Loading msg="loading" v-if="!isload" />
		<div class="skintype_part" v-else>
        	<img @click="$parent.goBack()"
				v-lazy="'https://static.inertiabiotech.com/uniskin/reportv3/images/gene_test_back.png'"
				class="back_btn lazy"
				alt="" />
           <div class="skintype_head">
               <h1 class="head_title">肤质结果</h1>
               <div class="fixed_part" :class="searchBarFixed ? 'fixed' : ''">
               <div class="head_result">
                   <h3 class="head_result_title">当前肤质:{{skintype_data.oil_result}}</h3>
                   <p class="head_result_info">{{skintype_data.oil_result_info}}</p>
                   <span class="skintype_doubt_btn" @click="$parent.linkGo('https://www.uniskin.com.cn/kefu/Index/index/mobile/from/report', (actParams = { query: $route.query, pageid: 1 }))">有疑问</span>
               </div>
               <ul class="head_cate">
                   <li class="head_cate_name" :class="focused_idx == 0 ? 'now' : ''" @click="changeFocusedTab(0);$parent.trackLog((actParams = { query: $route.query, pageid:403 }),{is_access:true,reportEvent_page_id:403,reportEvent_page_name:'表型-肤质-肤质分析',reportEvent_report_type:'199基因',reportEvent_first_module:'现状结果',reportEvent_second_module:'肤质',reportEvent_third_module:'分析'});" ref="focused_item_0">肤质分析</li>
                   <li class="head_cate_name" :class="focused_idx == 1 ? 'now' : ''" @click="changeFocusedTab(1);$parent.trackLog((actParams = { query: $route.query, pageid:404 }),{is_access:true,reportEvent_page_id:404,reportEvent_page_name:'表型-肤质-调理肤质',reportEvent_report_type:'199基因',reportEvent_first_module:'现状结果',reportEvent_second_module:'肤质',reportEvent_third_module:'调理'});" ref="focused_item_1">调理肤质</li>
                   <li class="head_cate_name" :class="focused_idx == 2 ? 'now' : ''" @click="changeFocusedTab(2);$parent.trackLog((actParams = { query: $route.query, pageid:405 }),{is_access:true,reportEvent_page_id:405,reportEvent_page_name:'表型-肤质-肤质小知识',reportEvent_report_type:'199基因',reportEvent_first_module:'现状结果',reportEvent_second_module:'肤质',reportEvent_third_module:'小知识'});" ref="focused_item_2">肤质小知识</li>
                    <span class="bg_div" :style="'width:' + focused_width + 'px;left:' + focused_left + 'px'"></span>
               </ul>
               </div>
           </div>
           <!-- 详情 -->
           <!-- 肤质分析 -->
            <div class="skintype_result" v-if="focused_idx == 0">
           
                        <div class="face_result">
                            <div class="face_result_item result_v"><img v-lazy="skintype_data.face_address" alt="" :key="'face_result_v_pic'"><p>脸颊</p></div>
                            <div class="face_result_item result_t"><img v-lazy="skintype_data.head_address" alt="" :key="'face_result_t_pic'"><p>T区</p></div>
                        </div>
                        <div class="oil_result_part">
                            <div class="oil_result_title">出油量分析</div>
                            <div class="oil_result_detail">
                                <span class="detail_name">脸颊</span>
                                <div class="detail_level_box">
                                    <div class="level_outer"><div class="level_progress" :style="{'width':skintype_data.oil_face_process+'%'}"></div></div>
                                    <div class="level_mark"><span class="low_mark mark_item">干</span><span class="high_mark mark_item">油</span></div>
                                    <img src="../assets/images/trangle_icon.png" class="trangle_icon" :style="{'left':skintype_data.oil_face_process+'%'}" alt="">
                                    <span class="level_per" :style="{'left':skintype_data.oil_face_process+'%'}">{{skintype_data.oil_face_process}}%&nbsp;&nbsp;{{skintype_data.face_process_info}}</span>
                                    <!-- <span class="level_text" :style="{left:skintype_data.oil_face_process+'%'}">{{skintype_data.face_process_info}}</span> -->
                                </div>
                            </div>

                               <div class="oil_result_detail">
                                <span class="detail_name">T区</span>
                                <div class="detail_level_box">
                                    <div class="level_outer"><div class="level_progress" :style="{width:skintype_data.oil_head_process+'%'}"></div></div>
                                    <div class="level_mark"><span class="low_mark mark_item">干</span><span class="high_mark mark_item">油</span></div>
                                    <img src="../assets/images/trangle_icon.png" class="trangle_icon" :style="{left:skintype_data.oil_head_process+'%'}" alt="">
                                    <span class="level_per" :style="{left:skintype_data.oil_head_process+'%'}">{{skintype_data.oil_head_process}}%&nbsp;&nbsp;{{skintype_data.head_process_info}}</span>
                                    <!-- <span class="level_text" :style="{left:skintype_data.oil_head_process+'%'}">{{skintype_data.head_process_info}}</span> -->
                                </div>
                            </div>
                        </div>
                      

                        <!-- 肤质特征部分 -->
                        <div class="pheno_2nd_title skintype_feature_title"><span>{{skintype_data.oil_result}}肤质的特征</span></div>
                        <p class="skintype_feature_sub_text">{{skintype_des_list[skintype_data.type_flag].feature}}</p>
                        <div class="skintype_des_box">
                            <div class="des_title_box">
                                <span>优势</span>
                                <span>劣势</span>
                            </div>
                            <div class="des_info_box">
                                <ul class="info_item info_text"><li v-for="(adv,index) in skintype_des_list[skintype_data.type_flag].advantage" :key="index">{{adv}}</li></ul>
                                <div class="info_item info_split_line"></div>
                                <ul class="info_item info_text"><li v-for="(disadv,index) in skintype_des_list[skintype_data.type_flag].disadvantage" :key="index">{{disadv}}</li></ul>
                            </div>
                        </div>
                      
            </div>
           <!-- 护肤推荐 -->
           <div class="skintype_rec" v-if="focused_idx == 1">
             <!-- <div class="skintype_rec_item">
                <div class="rec_item_title">使用温和的洗面奶</div>
                <p class="rec_item_info">混干肤质不能用太强力的洗面奶,因为这样会洗去过多的油脂,破坏天然的油脂保护层.皂基、带有磨砂颗粒的洗面奶是不能用的.</p>
                    <div class="rec_pro_info">
                    <img src="../assets/images/d20.png" class="info_item info_pic" alt="">
                     <div class="info_item info_detail">
                         <div class="detail_name">优时颜新能鲜活精粹乳</div>
                         <ul class="detail_effect"><li>去痘印</li><li>抗氧化</li></ul>
                         <ul class="detail_tag"><li>氨基酸</li></ul>
                     </div>
                    <div class="info_item info_link"><span class="discount_text">会员价</span><img src="../assets/images/arrow_right.png" class="link_icon" alt=""></div>
                </div>
             </div> -->
              <div class="skintype_rec_item" v-for="(list_item,idx) in skintype_step_list[skintype_data.type_flag]" :key="idx">
                <div class="rec_item_title">{{list_item.name}}</div>
                <p class="rec_item_info">{{list_item.des}}</p>
                <template v-if="list_item.haspro">
                  <div v-for="(pro_item,pro_idx) in filterSkintypePro(unrecommend_goodsid,idx)" :key="pro_idx">
                    <div class="rec_pro_info" @click="$parent.goMallDetail(pro_item.proid);">
                      <!-- $parent.trackLog((actParams = { query: $route.query, pageid:pro_item.pageid }),{is_access:true,reportEvent_page_id:pro_item.pageid,reportEvent_page_name:pro_item.name,reportEvent_report_type:'199基因',reportEvent_first_module:'基因结果',reportEvent_second_module:'产品详情'}); -->
                    <img :src="pro_list['proid'+pro_item.proid].img" :key="pro_item.proid" class="info_item info_pic" alt="">
                     <div class="info_item info_detail">
                         <div class="detail_name">{{pro_item.name.replace('优时颜','')}}</div>
                         <ul class="detail_effect"><li v-for="(tag_item,tag_idx) in pro_item.tag" :key="tag_idx">{{tag_item}}</li></ul>
                         <!-- <ul class="detail_tag"><li v-for="(ing_item,ing_idx) in pro_item.ing" :key="ing_idx">{{ing_item}}</li></ul> -->
                         <ul class="detail_tag"><li>{{pro_item.ing[0]}}</li></ul>
                     </div>
                    <div class="info_item info_link"><span class="discount_text">会员价</span><img src="../assets/images/arrow_right_d.png" class="link_icon" alt=""></div>
                </div>
               
                <p class="rec_use_tip" v-if="pro_item.toner && barrier_level_mark == 'good'">角质健康一般，可以用化妆棉辅助补水</p>
                <p class="rec_use_tip" v-if="pro_item.toner  && barrier_level_mark == 'nogood'">角质健康一般，可以用化妆棉辅助补水</p>
                </div>
                 </template>
             </div>
            <!-- <div class="skintype_rec_item">
                <div class="rec_item_title">使用温和的洗面奶</div>
                <p class="rec_item_info">混干肤质不能用太强力的洗面奶,因为这样会洗去过多的油脂,破坏天然的油脂保护层.皂基、带有磨砂颗粒的洗面奶是不能用的.</p>
          
             </div> -->
           </div>

           <!-- 肤质小知识 -->
           <div class="skintype_science" v-if="focused_idx == 2">
             <div class="science_title">肤质小知识</div>
             <img src="../assets/images/oil_structure_pic.jpg" class="science_pic" alt="">
             <p class="science_info">皮肤油脂中性分泌量为：68.7±13.5µg/cm²。面部不同部位油脂分泌量不同，额头和鼻子构成的T区油脂分泌量最高，比脸颊出油量平均高15µg/cm²，下巴出油量处于T区和脸颊之间，约有60-70µg/cm²。</p>
           </div>
		
		</div>
	</div>
</template>

<script>
import Loading from "./Loading.vue";
import axios from "axios";
var wx = require("weixin-js-sdk");
export default {
  name: "Skintype",
  data() {
    return {
      isload: false,
      in_weapp: false, //是否在小程序
       focused_idx:0,
      focused_left: '',
			focused_width: '',
      searchBarFixed: false,
      cate_show_index: "1", //1 显示肤质分析  2 显示护肤推荐  3显示肤质小知识
      html_pheno_record_time: "", //页面顶部检测时间
      show_recommend: false,
      skintype_result: "", //肤质结果
      skintype_data: {}, //肤质接口返回
      barrier_data: {}, //屏障接口返回
      melanin_data: {}, //黑色素接口返回
      display_ing: false, //成分弹窗
      ing_obj: {},
      unrecommend_goodsid: "",
      skintype_doubt_layer_show: false, //肤质疑问弹窗
      barrier_analysis_layer_show: false, //屏障解释弹窗
      melanin_analysis_layer_show: false, //黑色素解释弹窗
      barrier_scope_show: false, //屏障显微镜结果图
      melanin_scope_show: false, //黑色素显微镜结果图
      barrier_small_pic_show: false, //屏障结果小图片
      barrier_scope_large_pic_url:
        "https://static.inertiabiotech.com/uniskin/reportv3/images/barrier_sketch_pic.png", //屏障结果图大图路径
      barrier_scope_small_pic_url:
        "https://static.inertiabiotech.com/uniskin/reportv3/images/barrier_test_result_scope_pic.jpg", //屏障结果小图片路径
      barrier_level_mark: "",
      record_date: "",
      origin_scroll: null,
      barrier_des_obj: {
        //角质描述相关  三层从外到内  剥脱指数peel -> 排列指数arg -> 脱屑指数size
        peel: {
          1: {
            //剥脱指数peel危险
            arg: {
              1: {
                //排列指数arg危险
                size: {
                  1: {
                    //脱屑指数size危险
                    dqm_des: "角质层有比较严重的破损",
                    barrier_num: "3",
                    barrier_level: "屏障能力值较低",
                    barrier_des: "屏障受损，肌肤自我保护力很弱"
                  },
                  2: {
                    //脱屑指数size正常
                    dqm_des: "角质层的屏障功能不足",
                    barrier_num: "2",
                    barrier_level: "屏障能力值一般",
                    barrier_des: "屏障轻微受损，肌肤自我保护力被削弱"
                  },
                  3: {
                    //脱屑指数size优秀
                    dqm_des: "角质层的屏障功能不足",
                    barrier_num: "2",
                    barrier_level: "屏障能力值一般",
                    barrier_des: "屏障轻微受损，肌肤自我保护力被削弱"
                  }
                }
              },
              2: {
                //排列指数arg正常
                size: {
                  1: {
                    //脱屑指数size危险
                    dqm_des: "角质层出现破损，有起皮脱屑的问题",
                    barrier_num: "2",
                    barrier_level: "屏障能力值较低",
                    barrier_des: "屏障受损，肌肤自我保护力比较弱"
                  },
                  2: {
                    //脱屑指数size正常
                    dqm_des: "角质层的屏障功能有待提高",
                    barrier_num: "1",
                    barrier_level: "屏障能力值一般",
                    barrier_des: "屏障轻微受损，肌肤自我保护力被削弱"
                  },
                  3: {
                    //脱屑指数size优秀
                    dqm_des: "角质层的屏障功能有待提高",
                    barrier_num: "1",
                    barrier_level: "屏障能力值一般",
                    barrier_des: "屏障轻微受损，肌肤自我保护力被削弱"
                  }
                }
              },
              3: {
                //排列指数arg优秀
                size: {
                  1: {
                    //脱屑指数size危险
                    dqm_des: "角质层出现破损，有起皮脱屑的问题",
                    barrier_num: "2",
                    barrier_level: "屏障能力值较低",
                    barrier_des: "屏障受损，肌肤自我保护力比较弱"
                  },
                  2: {
                    //脱屑指数size正常
                    dqm_des: "角质层的屏障功能有待提高",
                    barrier_num: "1",
                    barrier_level: "屏障能力值一般",
                    barrier_des: "屏障轻微受损，肌肤自我保护力被削弱"
                  },
                  3: {
                    //脱屑指数size优秀
                    dqm_des: "角质层的屏障功能有待提高",
                    barrier_num: "1",
                    barrier_level: "屏障能力值一般",
                    barrier_des: "屏障轻微受损，肌肤自我保护力被削弱"
                  }
                }
              }
            }
          },
          2: {
            //剥脱指数peel正常
            arg: {
              1: {
                //排列指数arg危险
                size: {
                  1: {
                    //脱屑指数size危险
                    dqm_des: "角质层出现破损，有起皮脱屑的问题",
                    barrier_num: "2",
                    barrier_level: "屏障能力值较低",
                    barrier_des: "屏障受损，肌肤自我保护力比较弱"
                  },
                  2: {
                    //脱屑指数size正常
                    dqm_des: "角质层的屏障功能有待提高",
                    barrier_num: "1",
                    barrier_level: "屏障能力值一般",
                    barrier_des: "屏障轻微受损，肌肤自我保护力被削弱"
                  },
                  3: {
                    //脱屑指数size优秀
                    dqm_des: "角质层的屏障功能有待提高",
                    barrier_num: "1",
                    barrier_level: "屏障能力值一般",
                    barrier_des: "屏障轻微受损，肌肤自我保护力被削弱"
                  }
                }
              },
              2: {
                //排列指数arg正常
                size: {
                  1: {
                    //脱屑指数size危险
                    dqm_des: "角质层有起皮脱屑的问题",
                    barrier_num: "1",
                    barrier_level: "屏障能力值较低",
                    barrier_des: "屏障受损，肌肤自我保护力比较弱"
                  },
                  2: {
                    //脱屑指数size正常
                    dqm_des: "角质层没有特别严重的问题，但也有提升的空间",
                    barrier_num: "0",
                    barrier_level: "屏障能力值较高",
                    barrier_des: "屏障状态良好，肌肤自我保护力比较强"
                  },
                  3: {
                    //脱屑指数size优秀
                    dqm_des: "角质层没有特别严重的问题，但也有提升的空间",
                    barrier_num: "0",
                    barrier_level: "屏障能力值较高",
                    barrier_des: "屏障状态良好，肌肤自我保护力比较强"
                  }
                }
              },
              3: {
                //排列指数arg优秀
                size: {
                  1: {
                    //脱屑指数size危险
                    dqm_des: "角质层有起皮脱屑的问题",
                    barrier_num: "1",
                    barrier_level: "屏障能力值较低",
                    barrier_des: "屏障受损，肌肤自我保护力比较弱"
                  },
                  2: {
                    //脱屑指数size正常
                    dqm_des: "角质层没有特别严重的问题，但也有提升的空间",
                    barrier_num: "0",
                    barrier_level: "屏障能力值较高",
                    barrier_des: "屏障状态良好，肌肤自我保护力比较强"
                  },
                  3: {
                    //脱屑指数size优秀
                    dqm_des: "角质层状态很好",
                    barrier_num: "0",
                    barrier_level: "屏障能力值较高",
                    barrier_des: "屏障状态良好，肌肤自我保护力比较强"
                  }
                }
              }
            }
          },
          3: {
            //剥脱指数peel优秀
            arg: {
              1: {
                //排列指数arg危险
                size: {
                  1: {
                    //脱屑指数size危险
                    dqm_des: "角质层出现破损，有起皮脱屑的问题",
                    barrier_num: "2",
                    barrier_level: "屏障能力值较低",
                    barrier_des: "屏障受损，肌肤自我保护力比较弱"
                  },
                  2: {
                    //脱屑指数size正常
                    dqm_des: "角质层的屏障功能有待提高",
                    barrier_num: "1",
                    barrier_level: "屏障能力值一般",
                    barrier_des: "屏障轻微受损，肌肤自我保护力被削弱"
                  },
                  3: {
                    //脱屑指数size优秀
                    dqm_des: "角质层的屏障功能有待提高",
                    barrier_num: "1",
                    barrier_level: "屏障能力值一般",
                    barrier_des: "屏障轻微受损，肌肤自我保护力被削弱"
                  }
                }
              },
              2: {
                //排列指数arg正常
                size: {
                  1: {
                    //脱屑指数size危险
                    dqm_des: "角质层有起皮脱屑的问题",
                    barrier_num: "1",
                    barrier_level: "屏障能力值较低",
                    barrier_des: "屏障受损，肌肤自我保护力比较弱"
                  },
                  2: {
                    //脱屑指数size正常
                    dqm_des: "角质层没有特别严重的问题，但也有提升的空间",
                    barrier_num: "0",
                    barrier_level: "屏障能力值较高",
                    barrier_des: "屏障状态良好，肌肤自我保护力比较强"
                  },
                  3: {
                    //脱屑指数size优秀
                    dqm_des: "角质层状态很好",
                    barrier_num: "0",
                    barrier_level: "屏障能力值较高",
                    barrier_des: "屏障状态很好，肌肤自我保护力比较强"
                  }
                }
              },
              3: {
                //排列指数arg优秀
                size: {
                  1: {
                    //脱屑指数size危险
                    dqm_des: "角质层有起皮脱屑的问题",
                    barrier_num: "1",
                    barrier_level: "屏障能力值较低",
                    barrier_des: "屏障受损，肌肤自我保护力比较弱"
                  },
                  2: {
                    //脱屑指数size正常
                    dqm_des: "角质层状态很好",
                    barrier_num: "0",
                    barrier_level: "屏障能力值较高",
                    barrier_des: "屏障状态很好，肌肤自我保护力比较强"
                  },
                  3: {
                    //脱屑指数size优秀
                    dqm_des: "角质层状态非常好",
                    barrier_num: "0",
                    barrier_level: "屏障能力值较高",
                    barrier_des: "屏障状态很好，肌肤自我保护力比较强"
                  }
                }
              }
            }
          }
        }
      },
      pro_list: {
        //所有产品列表
        proid13: {
          name: "优能平衡霜",
          nickname: "平衡霜",
          cate: "面霜",
          desc: "神经酰胺", //优选成分
          loc: "13", //pid
          img:
            "https://static.inertiabiotech.com/uniskin/reportv3/images/Cream.png",
          demand: "cream",
          effect: "保湿 修护",
          suitfor: "任何肤质",
          ingredient: "神经酰胺&nbsp; 棕榈酰三肽-5",
          volume: "50G",
          price: "360",
          member_price: "320"
        },
        proid14: {
          name: "优能平衡乳",
          nickname: "平衡乳",
          cate: "乳液",
          desc: "野大豆甾醇类", //优选成分
          loc: "14", //pid
          img:
            "https://static.inertiabiotech.com/uniskin/reportv3/images/Lotion.png",
          demand: "lotion",
          effect: "保湿 修护 舒缓",
          suitfor: "油性 任何肤质",
          ingredient: "野大豆甾醇类",
          volume: "100G",
          price: "280",
          member_price: "250"
        },
        proid15: {
          name: "优能平衡水",
          nickname: "平衡水",
          cate: "水",
          desc: "糖类同分异构体,透明质酸钠,甘草酸二钾", //优选成分
          loc: "15", //pid
          img:
            "https://static.inertiabiotech.com/uniskin/reportv3/images/Toner.png",
          demand: "toner",
          effect: "补水 保湿 舒缓",
          suitfor: "任何肤质",
          ingredient: "糖类同分异构体&nbsp; 透明质酸钠&nbsp; 甘草酸二钾",
          volume: "130ML",
          price: "260",
          member_price: "220"
        },
        proid16: {
          name: "优能平衡洁面乳",
          nickname: "无",
          cate: "洁面",
          desc: "氨基酸表活", //优选成分
          loc: "16", //pid
          img:
            "https://static.inertiabiotech.com/uniskin/reportv3/images/Cleanser.png",
          demand: "cleanser",
          effect: "温和清洁",
          suitfor: "任何肤质",
          ingredient: "氨基酸表活",
          volume: "100G",
          price: "150",
          member_price: "95"
        },
        proid17: {
          //旅行套装
        },
        proid18: {
          name: "舒能柔肤精萃液",
          nickname: "HELA-1",
          cate: "精华",
          desc: "神经酰胺", //优选成分
          loc: "18", //pid
          img:
            "https://static.inertiabiotech.com/uniskin/reportv3/images/HELA_1.png",
          demand: "HELA_1",
          effect: "舒缓 修护",
          suitfor: "任何肤质",
          ingredient: "神经酰胺&nbsp; 迷迭香叶提取物",
          volume: "15G",
          price: "220",
          member_price: "150"
        },
        proid19: {
          name: "净能控油精萃乳 #2.1",
          nickname: "#2.1",
          cate: "精华",
          desc: "假交替单胞菌发酵产物提取物", //优选成分
          loc: "19", //pid
          img:
            "https://static.inertiabiotech.com/uniskin/reportv3/images/PIPAR_1.png",
          demand: "PIPAR_1",
          effect: "控油",
          suitfor: "油性 混合性",
          ingredient: "假交替单胞菌发酵产物提取物",
          volume: "30G",
          price: "190",
          member_price: "180"
        },
        proid20: {
          name: "净能祛痘精萃乳",
          nickname: "PIPAR-2",
          cate: "精华",
          desc: "黄檗树皮提取物", //优选成分
          loc: "20", //pid
          img:
            "https://static.inertiabiotech.com/uniskin/reportv3/images/PIPAR_2.png",
          demand: "PIPAR_2",
          effect: "祛痘",
          suitfor: "油性 混合性",
          ingredient: "黄檗树皮提取物",
          volume: "15G",
          price: "220",
          member_price: "150"
        },
        proid21: {
          name: "净能祛痘凝胶",
          nickname: "PIPAR-G",
          cate: "凝胶",
          desc: "季铵盐-73", //优选成分
          loc: "21", //pid
          img:
            "https://static.inertiabiotech.com/uniskin/reportv3/images/PIPAR_G.png",
          demand: "PIPAR_G",
          effect: "祛痘",
          suitfor: "任何肤质 痘痘部位使用",
          ingredient: "乙醇&nbsp; 角鲨烷&nbsp; 甘草酸二钾&nbsp; 季铵盐-73",
          volume: "15G",
          price: "160",
          member_price: "95"
        },
        proid22: {
          name: "亮能晶透精萃液 #5.1",
          nickname: "#5.1",
          cate: "精华",
          desc: "凝血酸", //优选成分
          loc: "22", //pid
          img:
            "https://static.inertiabiotech.com/uniskin/reportv3/images/TYRA_1.png",
          demand: "TYRA_1",
          effect: "提亮肤色 均匀肤色 局部提亮",
          suitfor: "任何肤质",
          ingredient: "凝血酸&nbsp; 苯乙基间苯二酚&nbsp; 十一碳烯酰基苯丙氨酸",
          volume: "30G",
          price: "230",
          member_price: "199"
        },
        proid23: {
          name: "亮能净泽精萃液 #5.2",
          nickname: "#5.2",
          cate: "精华",
          desc: "*烟酰胺<strong>敏感肌慎用</strong>", //优选成分
          loc: "23", //pid
          img:
            "https://static.inertiabiotech.com/uniskin/reportv3/images/TYRA_2.png",
          demand: "TYRA_2",
          effect: "均匀肤色 局部提亮 修护 淡化痘印",
          suitfor: "任何肤质",
          ingredient: "*烟酰胺&nbsp; 光果甘草根提取物/光甘草定",
          volume: "30G",
          price: "230",
          member_price: "199"
        },
        proid24: {
          name: "悦能角质调理精萃液",
          nickname: "KERA-1",
          cate: "精华",
          desc: "乳酸", //优选成分
          loc: "27", //pid
          img:
            "https://static.inertiabiotech.com/uniskin/reportv3/images/KERA_1.png",
          demand: "KERA_1",
          effect: "局部提亮 淡化痘印 祛痘",
          suitfor: "油性 混合性 敏感肌局部使用",
          ingredient: "乳酸&nbsp; 苹果酸",
          volume: "15G",
          price: "190",
          member_price: "120"
        },
        proid25: {
          name: "新能盈润精萃液 #6.1",
          nickname: "#6.1",
          cate: "精华",
          desc: "乙酰基六肽-8", //优选成分
          loc: "26", //pid
          img:
            "https://static.inertiabiotech.com/uniskin/reportv3/images/ROSA_1.png",
          demand: "ROSA_1",
          effect: "改善皱纹 紧致",
          suitfor: "任何肤质",
          ingredient: "乙酰基六肽-8&nbsp; 棕榈酰三肽-1&nbsp; 棕榈酰四肽-7",
          volume: "30G",
          price: "360",
          member_price: "320"
        },
        proid26: {
          name: "新能紧致精萃液 #6.2",
          nickname: "#6.2",
          cate: "精华",
          desc: "乙酰基二肽-1 鲸蜡酯", //优选成分
          loc: "26", //pid
          img:
            "https://static.inertiabiotech.com/uniskin/reportv3/images/ROSA_2.png",
          demand: "ROSA_2",
          effect: "紧致 改善皱纹",
          suitfor: "任何肤质",
          ingredient: "乙酰基二肽-1&nbsp; 鲸蜡酯&nbsp; 乙酰基四肽-2",
          volume: "30G",
          price: "360",
          member_price: "320"
        },
        proid27: {
          name: "新能鲜活精萃乳 #6.3",
          nickname: "#6.3",
          cate: "精华",
          desc: "白藜芦醇", //优选成分
          loc: "27", //pid
          img:
            "https://static.inertiabiotech.com/uniskin/reportv3/images/ROSA_3.png",
          demand: "ROSA_3",
          effect: "均匀肤色 抗糖化 抗氧化 修护",
          suitfor: "任何肤质",
          ingredient: "*烟酰胺&nbsp; 合欢树皮提取物&nbsp; 白藜芦醇",
          volume: "30G",
          price: "360",
          member_price: "320"
        },
        proid28: {
          //无对应产品
        },
        proid29: {
          //肌肤分子检测
        },
        proid30: {
          name: "优能仿生修护面膜",
          nickname: "仿生面膜",
          cate: "面膜",
          desc: "透明质酸钠", //优选成分
          loc: "30", //pid
          img:
            "https://static.inertiabiotech.com/uniskin/reportv3/images/Mask.png",
          demand: "mask",
          effect: "补水 保湿",
          suitfor: "任何肤质",
          ingredient: "氨基酸&nbsp; 透明质酸钠",
          volume: "125G",
          price: "160",
          member_price: "95"
        },
        proid31: {
          //基因定制精华
        },
        proid32: {
          //眼部精华霜
          name: "优时颜淡纹眼部精华露",
          nickname: "微笑眼霜",
          cate: "眼霜",
          desc: "乙酰基六肽-8&nbsp; SYN-AKE&nbsp; 血清蛋白仿生肽 ", //优选成分
          loc: "32", //pid
          img:
            "https://static.inertiabiotech.com/uniskin/reportv3/images/EyeCream.png",
          demand: "eyeCream",
          effect: "改善眼周纹",
          suitfor: "任何肤质",
          ingredient: "乙酰基六肽-8&nbsp; SYN-AKE&nbsp; 血清蛋白仿生肽 ",
          volume: "18G",
          price: "360",
          member_price: "320"
        }
      },
      //各种肤质 对应 优势 劣势  描述 对应文案
      skintype_des_list: {
        youxing: {
          advantage: [
            "• 油脂能锁水，是天然的保湿剂",
            "• 皮脂中自带维E，能够抗氧化",
            "• 油皮的屏障功能通常比干皮好，更适合尝试医美"
          ],
          disadvantage: [
            "• 油脂堵塞毛孔易引起黑头、闭口、痘痘",
            "• 容易有毛孔粗大的困扰",
            "• 容易暗沉发黄"
          ],
          feature:
            "全脸皮脂分泌旺盛，经常泛油光，化妆后容易脱妆，这种就是油性皮肤。",
          feature_show: false
        },
        hunyou: {
          advantage: [
            "• 油脂能锁水，是天然的保湿剂",
            "• 皮脂中自带维E，能够抗氧化"
          ],
          disadvantage: [
            "• 油脂堵塞毛孔易引起黑头、闭口、痘痘",
            "• 出油多的部位容易有毛孔粗大的困扰"
          ],
          feature:
            "T区和脸颊的皮脂腺活跃程度不同，就是混合性皮肤，其中如果脸部整体偏油，就是混油性肤质。",
          feature_show: false
        },
        hunhexing: {
          advantage: [
            "• 兼具油皮和干皮的优点：",
            "• 油脂能锁水，是天然的保湿剂",
            "• 皮脂中自带维E，能够抗氧化",
            "• 出油少的部位具有细腻感，毛孔不明显"
          ],
          disadvantage: [
            "• T区和脸颊有不同的问题：",
            "• 出油多的部位，油脂堵塞毛孔易引起黑头、闭口、痘痘",
            "• 出油少的部位容易有干燥脱屑、皮肤纹理粗糙的问题"
          ],
          feature:
            "T区和脸颊的皮脂腺活跃程度不同就是混合性肤质，最典型的混合性是T区出油多、脸颊出油少。",
          feature_show: false
        },
        hungan: {
          advantage: [
            "• 具有油皮无法达到的细腻感，毛孔不会很明显",
            "•不泛油光，不用担心出油过多引起的肤色暗沉"
          ],
          disadvantage: [
            "• 皮肤比较薄，容易感到干燥，风吹日晒会刺激皮肤泛红",
            "• 如果不注意防晒，容易有晒斑"
          ],
          feature:
            "T区和脸颊的皮脂腺活跃程度不同，就是混合性皮肤，其中如果脸部整体偏干，就是混干性肤质。",
          feature_show: false
        },
        zhongxing: {
          advantage: [
            "• 皮肤水油平衡，既没有油皮的油腻感，也没有干皮的紧绷感",
            "• 易于保养，不需要特殊护理"
          ],
          disadvantage: ["• 是最佳的肤质状态，没有劣势"],
          feature:
            "中性皮肤各处的皮脂分泌量都很适宜，既不干燥也不油腻，是最佳的肤质状态。",
          feature_show: false
        },
        ganxing: {
          advantage: [
            "• 具有油皮无法达到的细腻感，毛孔不明显",
            "• 不泛油光，不用担心出油过多引起的肤色暗沉"
          ],
          disadvantage: [
            "• 皮肤比较薄，容易感到干燥，风吹日晒会刺激皮肤泛红",
            "• 如果不注意防晒，容易有晒斑",
            "• 比其它肤质更容易产生细纹"
          ],
          feature: "干性皮肤全脸的皮脂腺都不活跃，整体出油量少。",
          feature_show: false
        }
      },

      skintype_step_list: {
        //肤质护肤步骤列表  不同肤质对应不同护肤步骤
        //肤质 和屏障 护肤推荐 根据接口中 不应存在的goods_id 筛选
        youxing: [
          {
            haspro: true, //是否有产品推荐
            name: "合理清洁",
            des:
              "油皮的保养首先需要做好清洁，一天至少使用一次洗面奶，定期使用清洁面膜。要注意，不要为了追求洗脸“干净”而去使用清洁力过强、洗完有紧绷感的洗面奶，这样反而会破坏皮肤屏障，使得皮肤感觉又油又干。",
            des_show: false,
            pro: [
              {
                proid: "16",
                pageid: "324",
                mark: "proid16",
                effect_detail_title: "", // 产品对应 适合xx功效成分  标题  没有则为空
                effect_tag: "",
                name: "优时颜优能平衡洁面乳",
                toner: false,
                tag: ["氨基酸洗面奶", "温和清洁"],
                ing: ["氨基酸表活"]
              }
            ]
          },
          {
            haspro: true, //是否有产品推荐
            name: "控油",
            des:
              "使用控油护肤品可以帮助减少油脂分泌，改善油光暗沉的情况，同时也能防止油脂堵塞毛孔，预防闭口、痘痘。另外，不要使用过于滋润的护肤品，例如油性质地的面霜，这类产品会加重油腻感，甚至闷痘。",
            des_show: false,
            pro: [
              {
                proid: "19",
                pageid: "327",
                mark: "proid19",
                effect_detail_title: "适合您的控油功效成分", // 产品对应 适合xx功效成分  标题  没有则为空
                effect_tag: "kongyou",
                name: "优时颜净能控油精萃乳#2.1",
                toner: false,
                tag: ["控油精华", "海洋菌种提取物"],
                ing: ["假交替单胞菌发酵产物提取物"]
              }
            ]
          },
          {
            haspro: false, //是否有产品推荐
            name: "饮食清淡、补充B族维生素",
            des:
              "多吃清淡、低GI的食物能够帮助皮肤减少油脂分泌，同时也要注意膳食中补充维生素B2、B6，绿叶蔬菜、豆类都是不错的选择。",
            des_show: false
          }
        ],
        hunyou: [
          //两种情况
          {
            haspro: true, //是否有产品推荐
            name: "合理清洁",
            des:
              "容易出油的部位要做好清洁，用洗面奶的泡沫打圈按摩。也可以定期使用清洁面膜。要注意，不要为了追求洗脸“干净”而去使用清洁力过强、洗完有紧绷感的洗面奶，这样反而会破坏皮肤屏障，使得皮肤感觉又油又干。",
            des_show: false,
            pro: [
              {
                proid: "16",
                pageid: "324",
                mark: "proid16",
                effect_detail_title: "",
                effect_tag: "", // 产品对应 适合xx功效成分  标题  没有则为空
                name: "优时颜优能平衡洁面乳",
                toner: false,
                tag: ["氨基酸洗面奶", "温和清洁"],
                ing: ["氨基酸表活"]
              }
            ]
          },
          {
            haspro: true, //是否有产品推荐
            name: "控油",
            des:
              "使用控油护肤品可以帮助减少油脂分泌，改善油光暗沉的情况，同时也能防止油脂堵塞毛孔，预防闭口、痘痘。另外，不要使用过于滋润的护肤品，例如油性质地的面霜，这类产品会加重油腻感，甚至闷痘。",
            des_oth:
              "混油肤质要注意分区护理皮肤，区别对待脸颊和T区：出油多的部位可以使用控油护肤品，帮助减少油脂分泌，防止油脂堵塞毛孔，并且不要用过于滋润的护肤品；出油不多的部位正常使用保湿产品即可。", //同时推荐两个
            des_show: false,
            pro: [
              {
                proid: "19",
                pageid: "327",
                mark: "proid19",
                effect_detail_title: "适合您的控油功效成分", // 产品对应 适合xx功效成分  标题  没有则为空
                effect_tag: "kongyou",
                name: "优时颜净能控油精萃乳#2.1",
                toner: false,
                tag: ["控油精华", "海洋菌种提取物"],
                ing: ["假交替单胞菌发酵产物提取物"]
              },
              {
                proid: "14",
                pageid: "322",
                mark: "proid14",
                effect_detail_title: "适合您的保湿功效成分", // 产品对应 适合xx功效成分  标题  没有则为空
                effect_tag: "baoshi",
                name: "优时颜优能平衡乳",
                toner: false,
                tag: ["保湿乳", "锁水", "神经酰胺"],
                ing: ["野大豆甾醇类"]
              }
            ]
          },
          {
            haspro: false, //是否有产品推荐
            name: "饮食清淡、补充B族维生素",
            des:
              "多吃清淡、低GI的食物能够帮助皮肤减少油脂分泌，同时也要注意膳食中补充维生素B2、B6，绿叶蔬菜、豆类都是不错的选择。",
            des_show: false
          }
        ],
        hunhexing: [
          {
            haspro: true, //是否有产品推荐
            name: "合理清洁",
            des:
              "容易出油的部位要认真清洁，用洗面奶的泡沫打圈按摩，也可以定期使用清洁面膜；出油不多的部位需要温和清洁，不可追求紧绷感。",
            des_show: false,
            pro: [
              {
                proid: "16",
                pageid: "324",
                mark: "proid16",
                effect_detail_title: "", // 产品对应 适合xx功效成分  标题  没有则为空
                effect_tag: "",
                name: "优时颜优能平衡洁面乳",
                toner: false,
                tag: ["氨基酸洗面奶", "温和清洁"],
                ing: ["氨基酸表活"]
              }
            ]
          },
          {
            haspro: true, //是否有产品推荐
            name: "分区护理：控油+保湿",
            des:
              "混合性肤质要注意分区护理皮肤，区别对待脸颊和T区：出油多的部位可以使用控油护肤品，帮助减少油脂分泌，防止油脂堵塞毛孔，并且不要用过于滋润的护肤品；出油少的部位要注重保湿，可以用比较滋润的护肤品，防止因为干燥而出现干纹、细纹。",
            des_show: false,
            pro: [
              {
                proid: "19",
                pageid: "327",
                mark: "proid19",
                effect_detail_title: "适合您的控油功效成分", // 产品对应 适合xx功效成分  标题  没有则为空
                effect_tag: "kongyou",
                name: "优时颜净能控油精萃乳#2.1",
                toner: false,
                tag: ["控油精华", "海洋菌种提取物"],
                ing: ["假交替单胞菌发酵产物提取物"]
              },
              {
                proid: "14",
                pageid: "322",
                mark: "proid14",
                effect_detail_title: "适合您的保湿功效成分", // 产品对应 适合xx功效成分  标题  没有则为空
                effect_tag: "baoshi",
                name: "优时颜优能平衡乳",
                toner: false,
                tag: ["保湿乳", "锁水", "神经酰胺"],
                ing: ["野大豆甾醇类"]
              }
            ]
          }
        ],
        hungan: [
          {
            haspro: true, //是否有产品推荐
            name: "温和清洁",
            des:
              "混干肤质不能用太强力的洗面奶，因为这样会洗去过多的油脂，破坏皮肤天然的油脂保护层。皂基、带有磨砂颗粒的洗面奶是不能用的。",
            des_show: false,
            pro: [
              {
                proid: "16",
                pageid: "324",
                mark: "proid16",
                effect_detail_title: "", // 产品对应 适合xx功效成分  标题  没有则为空
                effect_tag: "",
                name: "优时颜优能平衡洁面乳",
                toner: false,
                tag: ["氨基酸洗面奶", "温和清洁"],
                ing: ["氨基酸表活"]
              }
            ]
          },
          {
            haspro: true, //是否有产品推荐
            name: "注重保湿",
            des:
              "混干皮自身的皮脂分泌不足，需要借助护肤品来帮助锁水。护肤的最后一步要用保湿乳或者保湿霜把水分锁住，干燥的地方多涂一点，加强保湿的持久性。",
            des_show: false,
            pro: [
              {
                proid: "14",
                pageid: "322",
                mark: "proid14",
                effect_detail_title: "适合您的保湿功效成分", // 产品对应 适合xx功效成分  标题  没有则为空
                effect_tag: "baoshi",
                name: "优时颜优能平衡乳",
                toner: false,
                tag: ["保湿乳", "锁水", "神经酰胺"],
                ing: ["野大豆甾醇类"]
              }
            ]
          },
          {
            haspro: false, //是否有产品推荐
            name: "饮食补充Omega-3",
            des:
              "Omega-3能帮助肌肤调节油脂分泌，缓解干燥问题，可以通过三文鱼、核桃、亚麻籽、奇亚籽等食物进行补充。",
            des_show: false
          }
        ],
        zhongxing: [
          {
            haspro: true, //是否有产品推荐
            name: "温和清洁",
            des:
              "使用温和的洗面奶，不过度清洁，保持皮肤表面有天然的油脂保护层。",
            des_show: false,
            pro: [
              {
                proid: "16",
                pageid: "324",
                mark: "proid16",
                effect_detail_title: "", // 产品对应 适合xx功效成分  标题  没有则为空
                effect_tag: "",
                name: "优时颜优能平衡洁面乳",
                toner: false,
                tag: ["氨基酸洗面奶", "温和清洁"],
                ing: ["氨基酸表活"]
              }
            ]
          },
          {
            haspro: true, //是否有产品推荐
            name: "日常保湿",
            des:
              "中性皮肤不需要很复杂的保养，但也需要做好日常保湿，维持良好的皮肤状态。",
            des_show: false,
            pro: [
              {
                proid: "14",
                pageid: "322",
                mark: "proid14",
                effect_detail_title: "适合您的保湿功效成分", // 产品对应 适合xx功效成分  标题  没有则为空
                effect_tag: "baoshi",
                name: "优时颜优能平衡乳",
                toner: false,
                tag: ["保湿乳", "锁水", "神经酰胺"],
                ing: ["野大豆甾醇类"]
              }
            ]
          }
        ],
        ganxing: [
          //两种情况
          {
            haspro: true, //是否有产品推荐
            name: "温和清洁",
            des:
              "干皮不能用强力的洗面奶，因为这样会洗去过多的油脂，使得皮肤更干。应当避开皂基、带有磨砂颗粒的洗面奶。",
            des_show: false,
            pro: [
              {
                proid: "16",
                pageid: "324",
                mark: "proid16",
                effect_detail_title: "", // 产品对应 适合xx功效成分  标题  没有则为空
                effect_tag: "",
                name: "优时颜优能平衡洁面乳",
                toner: false,
                tag: ["氨基酸洗面奶", "温和清洁"],
                ing: ["氨基酸表活"]
              }
            ]
          },
          {
            haspro: true, //是否有产品推荐
            name: "注重保湿和屏障养护",
            des:
              "干皮自身的皮脂分泌不足，需要借助护肤品来帮助锁水。护肤品要选择滋润型的，护肤的最后一步用保湿乳或者保湿霜把水分锁住，干燥的地方厚涂，加强保湿的持久性。",
            des_show: false,
            pro: [
              {
                proid: "14",
                pageid: "322",
                mark: "proid14",
                effect_detail_title: "适合您的保湿功效成分", // 产品对应 适合xx功效成分  标题  没有则为空
                effect_tag: "baoshi",
                name: "优时颜优能平衡乳",
                toner: false,
                tag: ["保湿乳", "锁水", "神经酰胺"],
                ing: ["野大豆甾醇类"]
              },
              {
                proid: "13",
                pageid: "321",
                mark: "proid13",
                effect_detail_title: "适合您的保湿功效成分", // 产品对应 适合xx功效成分  标题  没有则为空
                effect_tag: "baoshi",
                name: "优时颜优能平衡霜",
                toner: false,
                tag: ["保湿霜", "滋养", "神经酰胺"],
                ing: ["神经酰胺", "棕榈酰三肽-5"]
              }
            ]
          },
          {
            haspro: false, //是否有产品推荐
            name: "饮食补充Omega-3",
            des:
              "Omega-3能帮助肌肤调节油脂分泌，缓解干燥问题，可以通过三文鱼、核桃、亚麻籽、奇亚籽等食物进行补充。",
            des_show: false
          }
        ]
      },

      ing_cate_obj: {
        kangyanghua: {
          name: "适合您的抗氧化功效成分",
          ing: [
            //黑色素 抗氧化功效成分
            {
              name: "VC（及其衍生物）",
              effect: "具有美白祛斑、抗氧化的功能"
            },
            {
              name: "白藜芦醇",
              effect:
                "3,5,4-三羟基芪结构，对酪氨酸酶具有高度亲和力，强效抑制酪氨酸酶活性，并且具有强大的抗氧化活性"
            },
            {
              name: "虾青素",
              effect: "高效抗氧化作用，清除自由基"
            },
            {
              name: "葡萄籽提取物",
              effect: "清除自由基，抗氧化"
            },
            {
              name: "生育酚（维生素E）",
              effect: "高效抗氧化，减少自由基对皮肤的损伤，延缓衰老"
            }
          ]
        },
        danban: {
          name: "适合您的淡斑功效成分",
          ing: [
            //黑色素 淡斑功效成分
            {
              name: "烟酰胺",
              effect:
                "抑制黑素体迁移，美白均匀肤色，帮助修复UV引起的DNA损伤。同时可以平衡角质层的神经酰胺和脂肪酸水平，帮助加强肌肤屏障"
            },
            {
              name: "VC（及其衍生物）",
              effect: "具有美白祛斑、抗氧化的功能"
            },
            {
              name: "光果甘草根提取物/光甘草定",
              effect: "抑制TYR、TRP-2的活性，减少色素沉着，同时具有抗炎作用"
            },
            {
              name: "凝血酸",
              effect:
                "蛋白酶（plasmin）抑制剂，能抑制蛋白酶对肽键水解的催化作用，抑制酪氨酸酶和黑色素细胞活性，并防止黑色素聚集"
            }
          ]
        },
        kongyou: {
          name: "适合您的控油功效成分",
          ing: [
            //肤质 控油功效成分
            {
              name: "假交替单胞菌发酵产物提取物",
              effect:
                "降低MC5-R（与皮脂腺细胞分化有关）的蛋白质水平，减少皮脂腺细胞的成熟及脂质过氧化，从而减少面部油光"
            },
            {
              name: "榆绣线菊提取物",
              effect: "具有抑菌（表皮葡萄球菌和痤疮丙酸杆菌）作用，减少粉刺发生"
            },
            {
              name: "葡糖酸锌",
              effect: "具有控油作用"
            },
            {
              name: "PCA锌",
              effect: "调节皮肤分泌量，还有保湿和抑菌作用"
            }
          ]
        },
        baoshi: {
          name: "适合您的保湿功效成分",
          ing: [
            //肤质保湿功效成分
            {
              name: "野大豆甾醇类",
              effect:
                "维持角质层中层状脂质结构，从而帮助受损肌肤恢复天然屏障功能"
            },
            {
              name: "牛油果树果脂",
              effect:
                "含多种不饱和脂肪酸，具有滋润修复效果，特别是针对干性肌肤和屏障受损肌肤"
            },
            {
              name: "神经酰胺",
              effect: "角质层脂质重要组成部分，修复皮肤屏障"
            },
            {
              name: "泛醇",
              effect: "维生素B5，具有保湿、修复功能"
            }
          ]
        },
        bushui: {
          name: "适合您的补水功效成分",
          ing: [
            //屏障 补水功效成分
            {
              name: "透明质酸钠",
              effect: "细胞外基质组成部分，天然大分子保湿剂，有很好的保水功效"
            },
            {
              name: "氨基酸",
              effect: "小分子氨基酸，起到保湿调理作用"
            },
            {
              name: "PCA钠",
              effect: "天然保湿因子，增强自身保湿力"
            },
            {
              name: "甘油葡糖苷",
              effect: "增加水合度，长效补水保湿"
            }
          ]
        },

        xiufu: {
          name: "适合您的修复功效成分",
          ing: [
            //屏障修复功效成分
            {
              name: "神经酰胺",
              effect: "角质层脂质重要组成部分，修复皮肤屏障"
            },
            {
              name: "水杨酰植物鞘氨醇",
              effect: "影响角质细胞基因的表达；促进神经酰胺的合成，增强皮肤屏障"
            },
            {
              name: "甲瓦龙酸内酯",
              effect: "促进神经酰胺生成，增强皮肤屏障功能"
            },
            {
              name: "野大豆甾醇类",
              effect:
                "维持角质层中层状脂质结构，从而帮助受损肌肤恢复天然屏障功能"
            },
            {
              name: "牛油果树果脂",
              effect:
                "含多种不饱和脂肪酸，具有滋润修复效果，特别是针对干性肌肤和屏障受损肌肤"
            }
          ]
        }
      },

      imgs: [
        require("../assets/images/1.png"),
        require("../assets/images/2.png"),
        require("../assets/images/3.png"),
        require("../assets/images/4.png")
      ],
      demopic: require("../assets/images/10.png")
    };
  },
    watch: {
    $route(to, from) {
      console.log("to", to);
	  this.initSkintype(to.params.bar_code || "");
	  console.log(to.params.bar_code);
    }
  },
  mounted: function() {
    var ua = navigator.userAgent.toLowerCase(),
      that = this;
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      wx.miniProgram.getEnv(res => {
        if (res.miniprogram) {
          console.log("在小程序里");
          that.in_weapp = true;
        }
      });
    }
    // window.addEventListener("scroll", this.handleScroll);
  },
  destroyed: function() {
    // window.removeEventListener("scroll", this.handleScroll);
  },
  created() {
    console.log("skintype created");
    this.initSkintype(
      this.$route.params.bar_code == "undefined"
        ? ""
        : this.$route.params.bar_code || ""
    );
    console.log(this.unrecommend_goodsid);
    console.log(this.barrier_level_mark);
    console.log(this.skintype_data);
  },
  methods: {
      changeFocusedTab: function(idx) {
			this.focused_idx = idx;
			console.log(271, this.$refs['focused_item_' + idx]);
			this.focused_width = this.$refs['focused_item_' + idx].clientWidth;
			this.focused_left = this.$refs['focused_item_' + idx].offsetLeft;
		},
    goMallDetail: function(pid) {
      if (this.in_weapp) {
        wx.miniProgram.navigateTo({
          url: "/mall-detail/mall-detail?scene=" + pid
        });
      } else {
        location.href =
          "https://www.uniskin.com.cn/homepage/m/pro_detail.html?p=" + pid;
      }
    },
    markpopupBtn: function() {
      this.markpopup.show = false;
      let _status = this.total_data.data.targetquestions.tag;
      if (_status == 1) {
        this.$router.push("/article/explainoth");
      } else if (_status == 2) {
        this.$router.push("/article/explain");
      }
    },
    initActionLog: function(m, pageid) {
      if (m && pageid)
        return axios.get("/mall/member/reportV2/actionlog", {
          params: { m, pageid }
        });
    },
    handleScroll: function() {
      console.log("top", document.documentElement.scrollTop);
      var scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop,
        offsetTop = document.querySelector(".fixed_part").offsetTop;
      if (scrollTop > offsetTop) {
        this.searchBarFixed = true;
      } else {
        this.searchBarFixed = false;
      }
    },
    toTop: function(dom) {
      let that = this;
      that.Type = dom;
      setTimeout(function() {
        //  document.documentElement.scrollTop=0;
        // console.log('ref',that.$refs[dom+"_part"].scrollTop);
        console.log("top", document.documentElement.scrollTop);
        // that.$refs[dom+"_part"].scrollTop = 0;
        document.documentElement.scrollTop = 0;
        window.pageYOffset = 0;
        document.body.scrollTop = 0;
      }, 100);
    },
    filterSkintypePro: function(goods_id, index) {
      //肤质产品筛选
      console.log(1613, this, goods_id);
      console.log(
        this.skintype_step_list[this.skintype_data.type_flag][index].pro.filter(
          function(v) {
            return v.proid != goods_id;
          }
        )
      );
      return this.skintype_step_list[this.skintype_data.type_flag][
        index
      ].pro.filter(function(v) {
        return v.proid != goods_id;
      });
    },
    displayIng: function(item) {
      console.log(this.ing_cate_obj[item]);
      this.display_ing = true;
      this.ing_obj = this.ing_cate_obj[item];
    },
    //初始化 新表型  肤质项目详情
    initSkintype: function(bar_code) {
      let that = this;
      // var local_skintype = JSON.parse(localStorage.getItem('local_skintype'));
      // if (local_skintype && !bar_code) {
      // 	afterSkintype(local_skintype);
      // } else {
      that
        .$jsonp(
          "https://www.uniskin.com.cn/reportv2/index/skin_detection/getOilValue",
          { bar_code }
        )
        .then(json => {
          // Success.
          console.log("111", json);
          // localStorage.setItem("local_skintype", JSON.stringify(json));
          afterSkintype(json);
        })
        .catch(err => {
          // Failed.
          localStorage.clear();
          location.href =
            "https://www.uniskin.com.cn/mall/member/account/login";
        });
      // }

      function afterSkintype(skintype_data) {
        that.skintype_data = skintype_data.gene_result;
        that.skintype_result = skintype_data.gene_result.type_flag;
        that.unrecommend_goodsid =
          skintype_data.gene_result.unrecommend_products.id;
        that.record_date =
          skintype_data.gene_result.create_time.split("-")[0] +
          "年" +
          skintype_data.gene_result.create_time.split("-")[1] +
          "月" +
          skintype_data.gene_result.create_time.split("-")[2] +
          "日的检测";
        console.log(
          "idddddd",
          skintype_data.gene_result.unrecommend_products.id
        );
        console.log("idddddd", that.unrecommend_goodsid);
        return that.initBarrier(bar_code);
      }
    },
    //初始化  新表型 屏障详情
    initBarrier: function(bar_code) {
      let that = this;
      // var local_barrier = JSON.parse(localStorage.getItem('local_barrier'));
      // if (local_barrier && !bar_code) {
      // 	afterBarrier(local_barrier);
      // } else {
      that
        .$jsonp(
          "https://www.uniskin.com.cn/reportv2/index/skin_detection/getPeelValue",
          { bar_code }
        )
        .then(json => {
          // Success.
          console.log("222", json);
          // localStorage.setItem("local_barrier", JSON.stringify(json));
          afterBarrier(json);
        })
        .catch(err => {
          // Failed.
          localStorage.clear();
          location.href =
            "https://www.uniskin.com.cn/mall/member/account/login";
        });
      // }

      function afterBarrier(barrier_data) {
        that.isload = true;

        that.barrier_level_mark =
          barrier_data.gene_result.dqm_result.dqmtype_flag;
        console.log(that.barrier_level_mark);
         setTimeout(() => {
						that.changeFocusedTab(that.focused_idx);
					}, 300);
      }
    }
  },
  components: {
    Loading
  }
};
</script>
<style lang="less" scoped>
@import "../styles/mixin.less";
@import "../styles/reset.less";
.bg_div{
  position:absolute;
  bottom:0;
  height:3px;
  width:1/50rem;
  background:#f099a6;
  -webkit-transition:left 0.5s;
  transition:left 0.5s;
}
.fixed_part.fixed {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  padding-top: 20px;
  background: @bg_c_l;
  z-index: 999998;
}
.back_btn {
  position: fixed;
  top: 30/50rem;
  left: 0;
  z-index: 999999;
  width: 118/50rem;
  height: 54/50rem;
}
.skintype_part {
  background: @bg_c_m;
}
.skintype_head {
  box-sizing: border-box;
  background: @bg_c_l;
  padding: 107/50rem 0 0;
  .head_title {
    padding: 0 0 32/50rem;
    font-size: 36/50rem;
    line-height: 1em;
    font-weight: bold;
    text-align: center;
    color: @font-c-3;
  }
  .head_result {
    position: relative;
    box-sizing: border-box;
    width: 564/50rem;
    margin: 0 auto;
    .border-radius(14/50rem);
    padding: 40/50rem 20/50rem 55/50rem;
    .gradient(to right, @pheno-s-1, @pheno-e-1);
    .head_result_title {
      font-size: 36/50rem;
      line-height: 1em;
      color: @font-c-f;
      text-align: center;
      padding-bottom: 15/50rem;
    }
    .head_result_info {
      font-size: 28/50rem;
      line-height: 1em;
      color: @font-c-f;
      text-align: center;
    }
    .skintype_doubt_btn{
      position:absolute;
      right:0;
      top:0.8rem;
      width:2.6rem;
      height:0.8rem;
      background:#ffe6e3;
      border-radius:0.4rem 0 0 0.4rem;
      font-size:0.48rem;
      line-height:0.8rem;
      text-align:center;
      color:#f99d9b;
    }
  }
  .head_cate {
    position:relative;
    padding: 97/50rem 31/50rem 0;
    .box-shadow(4px,4px,13px,1px,rgba(197,197,197,0.24));
    .display_flex;
    .flex-wrap_nowrap;
    .justify-content_flex-justify;
    .head_cate_name {
      width: 33%;
      .flex_0;
      padding-bottom: 27/50rem;
      font-size: 28/50rem;
      line-height: 1em;
      color: @font-c-3;
      text-align: center;
      &.now {
        font-size: 34/50rem;
        font-weight: bold;
        // border-bottom: 2px solid #f099a6;
      }
    }
  }
}

//肤质结果
.skintype_result {
  padding: 78/50rem 30/50rem 0;
  border-bottom: 1px solid #fff;
  margin-bottom: 99/50rem;

  // 脸部图片区域
  .face_result {
    margin: 0 auto;
    position: relative;
    width: 404/50rem;
    height: 325/50rem;
    background: url("../assets/images/phenotypic_face_with_line.png") no-repeat
      0 0;
    background-size: 100%;
    .face_result_item {
      position: absolute;
      width: 122/50rem;
      height: 172/50rem;
      img {
        width: 122/50rem;
        height: 122/50rem;
        border-radius: 50%;
      }
      p {
        font-size: 24/50rem;
        line-height: 1em;
        color: #000;
        padding-top: 20/50rem;
        text-align: center;
      }
    }
    .result_v {
      top: 130/50rem;
      right: 400/50rem;
    }
    .result_t {
      top: 106/50rem;
      left: 400/50rem;
    }
  }
  // 油脂进度条区域
  .oil_result_part {
    padding: 59/50rem 0 10/50rem;
    .oil_result_title {
      padding-bottom: 43/50rem;
      font-size: 34/50rem;
      line-height: 1em;
      font-weight: bold;
      color: #333;
    }
    .oil_result_detail {
      padding-bottom: 35/50rem;
      padding: 0 30/50rem 35/50rem;
      display: flex;
      display: -webkit-flex;
      flex-wrap: nowrap;
      -webkit-flex-wrap: nowrap;
      justify-content: flex-start;
      -webkit-justify-content: flex-start;
      .detail_name {
        flex: 0 0 auto;
        -webkit-flex: 0 0 auto;
        align-self: flex-start;
        -webkit-align-self: flex-start;
        font-size: 28/50rem;
        line-height: 1em;
        padding-right: 63/50rem;
      }
      .detail_level_box {
        position: relative;
        flex: 0 0 auto;
        -webkit-flex: 0 0 auto;
        align-self: flex-start;
        -webkit-align-self: flex-start;
        width: 494/50rem;
        padding-bottom: 41/50rem;
        .level_outer {
          width: 100%;
          height: 18/50rem;
          .border-radius(9/50rem);
          background: #fff;
          .level_progress {
            width: 30%;
            height: 100%;
            .border-radius(9/50rem);
            background: #f099a6;
          }
        }
        .level_mark {
          //    position:relative;
          //    height:0.82rem;
          .mark_item {
            position: absolute;
            font-size: 24/50rem;
            line-height: 1em;
            color: #333;
          }
          .low_mark {
            top: 0;
            left: -30/50rem;
          }
          .high_mark {
            top: 0;
            right: -30/50rem;
          }
        }
        .trangle_icon {
          width: 15/50rem;
          height: 15/50rem;
          position: absolute;
          top: 30/50rem;
          left: 75/50rem;
          transform: translateX(-50%);
        }
        .level_per {
          position: absolute;
          top: 50/50rem;
          left: 75/50rem;
          font-size: 24/50rem;
          line-height: 1em;
          white-space: nowrap;
          color: #666;
          transform: translateX(-50%);
        }
        .level_text {
          position: absolute;
          top: 50/50rem;
          left: 130/50rem;
          font-size: 24/50rem;
          line-height: 1em;
          color: #666;
        }
      }
    }
  }

  // 肤质特征 及 护肤列表部分
  .pheno_2nd_title {
    padding: 70/50rem 0 38/50rem;
    font-size: 34/50rem;
    font-weight: bold;
    line-height: 1em;
    color: #333;
  }
  .skintype_feature_sub_text {
    position: relative;
    box-sizing: border-box;
    padding-right: 0;
    margin-bottom: 12/50rem;
    font-size: 24/50rem;
    color: #666;
  }

  .skintype_des_box {
    box-shadow: 3px 3px 13px 1px rgba(213, 213, 213, 0.74);
    border-radius: 15/50rem;
    background: #fcfcfc;
    .des_title_box {
      display: flex;
      display: -webkit-flex;
      flex-wrap: nowrap;
      -webkit-flex-wrap: nowrap;
      justify-content: space-between;
      -webkit-justify-content: space-between;
      padding: 21/50rem 0 15/50rem;
      border-bottom: 1px solid #f0efef;
      span {
        flex: 0 0 auto;
        -webkit-flex: 0 0 auto;
        align-self: center;
        align-self: center;
        text-align: center;
        font-size: 28/50rem;
        line-height: 1em;
        color: #f099a6;
        width: 50%;
      }
    }
    .des_info_box {
      display: flex;
      display: -webkit-flex;
      flex-wrap: nowrap;
      -webkit-flex-wrap: nowrap;
      justify-content: space-between;
      -webkit-justify-content: space-between;
      padding: 24/50rem 0;
      .info_item {
        flex: 0 0 auto;
        -webkit-flex: 0 0 auto;
        align-self: flex-start;
        align-self: flex-start;
      }
      .info_text {
        box-sizing: border-box;
        width: 49.8%;
        padding: 0 30/50rem;
        font-size: 24/50rem;
        line-height: 28/50rem;
        color: #666;
        li {
          margin-bottom: 15/50rem;
        }
      }
      .info_split_line {
        width: 1/50rem;
        height: 140/50rem;
        background: #f6a68c;
        align-self: center;
      }
    }
  }
}

//肤质护肤推荐
.skintype_rec {
  padding-bottom: 142/50rem;
  .skintype_rec_item {
    padding: 80/50rem 30/50rem 0;
    .rec_item_title {
      font-size: 34/50rem;
      line-height: 1em;
      font-weight: bold;
      color: @font-c-3;
    }
    .rec_item_info {
      padding: 24/50rem 0 14/50rem;
      font-size: 24/50rem;
      line-height: 30/50rem;
      color: @font-c-6;
    }
    .rec_pro_info {
      background: @bg_c_l;
      box-sizing: border-box;
      padding: 18/50rem 26/50rem 18/50rem 9/50rem;
      .shadow;
      .border-radius(14/50rem);
      width: 100%;
      .display_flex;
      .flex-wrap_nowrap;
      .justify-content_flex-justify;
      .info_item {
        .flex_0;
        .align-items_center;
      }
      .info_pic {
        width: 163/50rem;
        height: 163/50rem;
      }
      .info_detail {
        width: 358/50rem;
        padding: 21/50rem 0;
        .detail_name {
          white-space: nowrap;
          font-size: 30/50rem;
          line-height: 1em;
          color: @font-c-3;
        }
        .detail_effect {
          padding: 23/50rem 0 14/50rem;
          .display_flex;
          .flex-wrap_wrap;
          .justify-content_flex-start;
          li {
            .flex_0;
            margin-right: 24/50rem;
             margin-bottom:5/50rem;
            font-size: 24/50rem;
            line-height: 1em;
            color: @font-c-9;
          }
        }
        .detail_tag {
          .display_flex;
          .flex-wrap_wrap;
          .justify-content_flex-start;
          li {
            padding: 8/50rem 22/50rem;
            .flex_0;
            margin-right: 24/50rem;
            font-size: 24/50rem;
            line-height: 1em;
            color: @font-c-9;
            .border-radius(25/50rem);
            border: 1/50rem solid #ff7278;
          }
        }
      }
      .info_link {
        .display_flex;
        .flex-wrap_nowrap;
        .justify-content_flex-end;
        .link_icon,
        .discount_text {
          .flex_0;
          .align-items_center;
        }
        .link_icon {
          width: 14/50rem;
          height: 27/50rem;
        }
        .discount_text {
          font-size: 24/50rem;
          color: @font-c-detail;
          padding-right: 7/50rem;
        }
      }
    }
    .rec_use_tip {
      padding: 10/50rem 0;
      font-size: 20/50rem;
      line-height: 1em;
      color: @font-c-detail;
    }
  }
}

//肤质小知识
.skintype_science {
  padding: 80/50rem 30/50rem 107/50rem;
  .science_title {
    padding-bottom: 46/50rem;
    font-size: 34/50rem;
    line-height: 1em;
    font-weight: bold;
    color: @font-c-3;
  }
  .science_pic {
    width: 100%;
  }
  .science_info {
    padding-top: 30/50rem;
    font-size: 24/50rem;
    line-height: 30/50rem;
    color: @font-c-6;
  }
}
</style>
